import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/settings/terms-and-conditions/$id/edit',
)({
  component: () => null,
});
